/*
  cart-variant-switcher.js
  ─────────────────────────────────────────────────────────────
  Adiciona um seletor de tamanho em cada item do cart-drawer.
  
  COMO USAR:
  1. Suba este arquivo em Admin → Loja online → Temas → Editar código → Assets
  2. No arquivo sections/header-group.liquid (ou onde o cart-drawer é carregado),
     adicione antes do </body>:
     <script src="{{ 'cart-variant-switcher.js' | asset_url }}" defer></script>
  ─────────────────────────────────────────────────────────────
*/

(function () {
  if (window.__tpVariantSwitcherInit) return;
  window.__tpVariantSwitcherInit = true;

  // ── ESTILOS ────────────────────────────────────────────────
  var style = document.createElement('style');
  style.textContent = `
    .tp-variant-switcher {
      display: flex;
      flex-wrap: wrap;
      gap: 4px;
      margin: 5px 0 2px;
    }
    .tp-variant-switcher__label {
      width: 100%;
      font-size: 10px;
      font-weight: 600;
      letter-spacing: 1.5px;
      text-transform: uppercase;
      color: #999;
      margin-bottom: 4px;
    }
    .tp-variant-switcher__btn {
      height: 24px;
      padding: 0 9px;
      border-radius: 4px;
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 0.5px;
      text-transform: uppercase;
      border: 1px solid rgba(0,0,0,0.12);
      background: #f5f5f5;
      cursor: pointer;
      transition: background 0.15s, color 0.15s, border-color 0.15s;
      color: #1a1a1a;
      -webkit-font-smoothing: antialiased;
    }
    .tp-variant-switcher__btn:hover {
      border-color: #1a1a1a;
      background: #f0f0f0;
    }
    .tp-variant-switcher__btn.active {
      background: #1a1a1a;
      color: #fff;
      border-color: #1a1a1a;
    }
    .tp-variant-switcher__btn.unavailable {
      opacity: 0.3;
      text-decoration: line-through;
      cursor: default;
      pointer-events: none;
    }
    .tp-variant-switcher__updating {
      opacity: 0.5;
      pointer-events: none;
    }
    /* Corrige botão de fechar do drawer */
    .cart-drawer__header {
      position: relative !important;
      z-index: 10 !important;
      background: var(--color-background, #fff) !important;
      display: flex !important;
      align-items: center !important;
      justify-content: space-between !important;
      padding-right: 16px !important;
    }
    .cart-drawer__close-button {
      position: relative !important;
      top: auto !important;
      right: auto !important;
      flex-shrink: 0 !important;
    }
    .cart-drawer__frete {
      display: block !important;
      visibility: visible !important;
      opacity: 1 !important;
    }
  `;
  document.head.appendChild(style);

  // ── BUSCA VARIANTES DO PRODUTO ─────────────────────────────
  var productCache = {};

  function fetchProductVariants(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        productCache[handle] = p;
        return p;
      });
  }

  // ── INJETA SELETOR EM CADA ITEM ────────────────────────────
  function injectSwitchers() {
    var rows = document.querySelectorAll('.cart-items__table-row[data-key]');
    rows.forEach(function (row) {
      if (row.querySelector('.tp-variant-switcher')) return; // já injetado

      var key = row.getAttribute('data-key');
      var variantId = key ? key.split(':')[0] : null;
      if (!variantId) return;

      // Acha o link do produto na linha
      var link = row.querySelector('a[href*="/products/"]');
      if (!link) return;
      var match = link.getAttribute('href').match(/\/products\/([^?]+)/);
      if (!match) return;
      var handle = match[1];

      fetchProductVariants(handle).then(function (product) {
        // Só mostra se tiver mais de uma variante
        if (!product.variants || product.variants.length <= 1) return;
        // Já foi injetado enquanto o fetch rodava
        if (row.querySelector('.tp-variant-switcher')) return;

        // Pega a primeira opção (ex: Tamanho)
        var optionIndex = 0; // option1
        var shownValues = {};
        var switcher = document.createElement('div');
        switcher.className = 'tp-variant-switcher';

        // Label "Tamanho: X"
        var label = document.createElement('span');
        label.className = 'tp-variant-switcher__label';
        var activeVariant = product.variants.find(function(v) { return String(v.id) === String(variantId); });
        label.textContent = 'Tamanho: ' + (activeVariant ? activeVariant.option1 : '');
        switcher.appendChild(label);

        product.variants.forEach(function (v) {
          var val = v.option1;
          if (shownValues[val]) return;
          shownValues[val] = true;

          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'tp-variant-switcher__btn' +
            (String(v.id) === String(variantId) ? ' active' : '') +
            (!v.available ? ' unavailable' : '');
          btn.textContent = val === 'Default Title' ? 'Único' : val;
          btn.setAttribute('data-variant-id', v.id);
          btn.setAttribute('data-product-id', product.id);

          btn.addEventListener('click', function () {
            if (btn.classList.contains('active')) return;
            // Atualiza label
            var lbl = switcher.querySelector('.tp-variant-switcher__label');
            if (lbl) lbl.textContent = 'Tamanho: ' + (v.option1 === 'Default Title' ? 'Único' : v.option1);
            changeVariant(row, product, v, switcher);
          });

          switcher.appendChild(btn);
        });

        // Injeta abaixo do nome do produto
        var infoCell = row.querySelector('.cart-items__info, td:nth-child(2), [headers="productInformation"]');
        if (infoCell) {
          var nameEl = infoCell.querySelector('a, .cart-items__name, [class*="name"]');
          if (nameEl) {
            nameEl.parentNode.insertBefore(switcher, nameEl.nextSibling);
          } else {
            infoCell.appendChild(switcher);
          }

          // Esconde textos duplicados que o tema renderiza abaixo dos pickers
          infoCell.querySelectorAll('.cart-items__variants').forEach(function(el) {
            el.style.display = 'none';
          });
          // Esconde o div de preço duplicado (contém .visually-hidden "Preço")
          infoCell.querySelectorAll('div').forEach(function(el) {
            if (el.querySelector('.visually-hidden') && el.querySelector('.visually-hidden').textContent.trim() === 'Preço') {
              el.style.display = 'none';
            }
          });
        }
      });
    });
  }

  // ── TROCA A VARIANTE NO CARRINHO ───────────────────────────
  function changeVariant(row, product, newVariant, switcher) {
    var key = row.getAttribute('data-key');
    var currentVariantId = key.split(':')[0];

    switcher.classList.add('tp-variant-switcher__updating');

    // Remove o item atual e adiciona o novo
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        updates: { [currentVariantId]: 0 }
      })
    })
    .then(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: newVariant.id, quantity: 1 })
      });
    })
    .then(function () {
      // Atualiza o drawer via Sections API
      var cartItems = document.querySelector('cart-items-component');
      var sectionId = cartItems ? cartItems.sectionId : null;
      if (!sectionId) {
        window.location.reload();
        return;
      }
      return fetch('/?sections=' + sectionId)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data[sectionId];
          if (!html) { window.location.reload(); return; }
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          var newItems = doc.querySelector('cart-items-component');
          var oldItems = document.querySelector('cart-items-component');
          if (newItems && oldItems) {
            oldItems.innerHTML = newItems.innerHTML;
            // Re-injeta os switchers após atualizar o DOM
            setTimeout(injectSwitchers, 100);
          }

          // Atualiza contador
          var newIcon = doc.querySelector('cart-icon');
          var oldIcon = document.querySelector('cart-icon');
          if (newIcon && oldIcon) oldIcon.innerHTML = newIcon.innerHTML;
        });
    })
    .catch(function () {
      switcher.classList.remove('tp-variant-switcher__updating');
    });
  }

  // ── OBSERVA MUDANÇAS NO DRAWER ────────────────────────────
  // Roda quando o drawer abre ou o conteúdo muda
  var observer = new MutationObserver(function () {
    injectSwitchers();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Tenta injetar imediatamente caso o drawer já esteja aberto
  injectSwitchers();

})();

// ── SWIPER LOOP FIX ───────────────────────────────────────
// Desativa loop automaticamente quando slides insuficientes
(function() {
  function fixSwiperLoop() {
    document.querySelectorAll('.swiper').forEach(function(el) {
      var swiper = el.swiper;
      if (!swiper || !swiper.params.loop) return;
      var needed = (swiper.params.slidesPerView || 1) * 2;
      if (swiper.slides.length < needed) {
        swiper.params.loop = false;
        swiper.loopDestroy && swiper.loopDestroy();
        swiper.update();
      }
    });
  }
  // Roda após o Swiper inicializar
  window.addEventListener('load', fixSwiperLoop);
  setTimeout(fixSwiperLoop, 500);
})();
